import { getUserGtmInfo, pushFormattedGtmEvent } from '@/logic/metrika/helpers'
import type { RootState } from '@/redux/interfaces'

export const pushOpenRegistrationModalGtmEvent = (state: RootState) => {
  pushFormattedGtmEvent({
    event: 'userEvent',
    pagePart: 'popUp',
    blockName: 'modalAuth',
    eventCategory: 'interactions',
    eventAction: 'viewing',
    eventLabel: 'modalAuthView',
    eventContext: null,
    eventEcommerce: null,
    eventNonInteraction: '0',
    firingOptions: 'oncePerEvent',
    ecommerce: null,
    userSegment: null,
    ...getUserGtmInfo()(state),
  })
}

export const pushOpenModalAuthConfirmGtmEvent = (state: RootState) => {
  pushFormattedGtmEvent({
    event: 'userEvent',
    pagePart: 'popUp',
    blockName: 'modalAuth',
    eventCategory: 'interactions',
    eventAction: 'click',
    eventLabel: 'modalAuthConfirm',
    eventContext: null,
    eventEcommerce: null,
    eventNonInteraction: '0',
    firingOptions: 'oncePerEvent',
    ecommerce: null,
    userSegment: null,
    ...getUserGtmInfo()(state),
  })
}
